// Central branding contract. UI implementations (React web, RN mobile) live
// under apps/{web,mobile} but MUST consume this contract; individual modules
// must not implement their own branding.
export interface BrandTokens {
  product_name: string;
  logo_url: string | null;
  compact_logo_url: string | null;
  favicon_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  accent_color: string | null;
  preferred_text_theme: 'light' | 'dark' | 'auto' | null;
  support_email: string | null;
  co_brand_mode: 'customer_only' | 'powered_by' | 'platform_default';
}
export const PLATFORM_DEFAULT_BRAND: BrandTokens = {
  product_name: 'EDV Reliability',
  logo_url: null,
  compact_logo_url: null,
  favicon_url: null,
  primary_color: '#0d2b45',
  secondary_color: '#1a5080',
  accent_color: '#4aa8ff',
  preferred_text_theme: 'auto',
  support_email: null,
  co_brand_mode: 'platform_default',
};
